import { REJECT, array, nullable, num, numeric, object, str, unknownValue, type FieldParser } from 'validation';

// The audit-trail envelope returned by every `/<resource>/audit_trail/:x`
// endpoint. The backend serves them all through ONE helper —
// `getAuditTrailByObjectTypeAndId` (nap-backend modules/generic_functions) — so
// the shape is shared by IDENTITY across zones, folders, … and lives here,
// imported wherever an audit trail is read (like folderPath / retentionPolicy).
//
// `audit_details` is object-type-specific freeform JSONB (a zone records an
// `action` + previous/new state; other object types differ), so it is kept
// opaque here — each viewer narrows it.
export interface AuditTrailEntry {
  readonly audit_trail_id: number;
  readonly audit_type: string;
  readonly user_id: number | null;
  readonly user_name: string | null;
  readonly audit_details: unknown;
  readonly created_at: string | null;
}

export interface AuditTrail {
  readonly object_type: string;
  readonly object_id: number;
  readonly audit_trail: readonly AuditTrailEntry[];
}

export const auditTrailEntrySchema: FieldParser<AuditTrailEntry> = object<AuditTrailEntry>({
  audit_trail_id: num(REJECT),
  audit_type: str(),
  user_id: nullable(num()),
  user_name: nullable(str()),
  audit_details: unknownValue(),
  created_at: nullable(str()),
});

export const auditTrailSchema: FieldParser<AuditTrail> = object<AuditTrail>({
  object_type: str(),
  object_id: numeric(),
  audit_trail: array(auditTrailEntrySchema),
});
